/* SBI tumbled stones - retailer profit math. Loaded on demand (first click / open), never on page load.
 * The RULES below are the live source for the storefront. The same numbers live in
 * sbi-tumbled-stones-page/scripts/math_rules.py (used for the data table + charts). Change both together.
 */
(function () {
  if (window.SBITumble) return;

  var RULES = {
    // cheaper stones carry a higher multiple: [max cost per stone, multiple]
    multiples: [[0.25, 6], [0.5, 5], [1, 4], [2, 3.5], [Infinity, 3]],
    // lowest shelf price per size tier (Arthur: a medium should be at least $2)
    floors: { mini: 0.25, xs: 0.25, s: 0.5, m: 2, l: 3, xl: 4, xxl: 5, single: 0 },
    pricePoints: [0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 15, 18, 20, 25, 30, 35, 40, 45, 50, 60, 75, 90, 100, 125, 150],
    // typical stones in a 1 lb bag of an average-density stone, by size tier
    typical1lb: { mini: [250, 350], xs: [141, 250], s: [61, 140], m: [25, 60], l: [15, 24], xl: [6, 14], xxl: [4, 6] },
    heavy: ['pyrite', 'hematite', 'magnetite', 'galena', 'bornite', 'chalcopyrite', 'shungite elite', 'cinnabar', 'barite'],
    heavyFactor: 0.55,
    minCostPerStone: 0.02,
    maxMultiple: 15
  };
  var BAG_LB = [[/1\/4\s*lb/, 0.25], [/1\/2\s*lb/, 0.5], [/\b1\s*lb/, 1], [/500\s*g/, 1.1], [/1\s*kg/, 2.2], [/50\s*g/, 0.11], [/10\s*g/, 0.022]];
  var TIER_NAME = { mini: 'Mini / Tiny', xs: 'X-Small', s: 'Small', m: 'Medium', l: 'Large', xl: 'X-Large', xxl: 'XX-Large', single: 'Single' };

  function tier(name) {
    var s = (name || '').toLowerCase();
    if (/tiny|mini|chip|crushed/.test(s)) return 'mini';
    if (/xx[- ]?l/.test(s)) return 'xxl';
    if (/\b(x[- ]?large|extra[- ]?large|xl)\b/.test(s)) return 'xl';
    if (/\b(x[- ]?small|extra[- ]?small|xs)\b/.test(s)) return 'xs';
    if (s.indexOf('large') > -1) return 'l';
    if (s.indexOf('medium') > -1 || s.indexOf('assorted') > -1) return 'm';
    if (s.indexOf('small') > -1) return 's';
    return null;
  }
  function multipleFor(cost) {
    for (var i = 0; i < RULES.multiples.length; i++) if (cost <= RULES.multiples[i][0]) return RULES.multiples[i][1];
    return 3;
  }
  function pricePointUp(x) {
    for (var i = 0; i < RULES.pricePoints.length; i++) if (RULES.pricePoints[i] >= x - 1e-9) return RULES.pricePoints[i];
    return Math.ceil(x / 5) * 5;
  }
  function parsePieces(t) {
    if (!t) return null;
    var m = String(t).match(/^\s*(\d+)\s*(?:to|-)\s*(\d+)\s*$/);
    if (m) return [+m[1], +m[2]];
    m = String(t).match(/^\s*(\d+)\s*$/);
    return m ? [+m[1], +m[1]] : null;
  }
  function bagLb(soldBy, title) {
    var s = ((soldBy || '') + ' ' + (title || '')).toLowerCase();
    for (var i = 0; i < BAG_LB.length; i++) if (BAG_LB[i][0].test(s)) return BAG_LB[i][1];
    return null;
  }
  function packCount(soldBy, title, vt) {
    var s = [soldBy, title, vt].join(' | ').toLowerCase();
    var m = s.match(/(\d+)\s*pack|pack of (\d+)|(\d+)\s*stones/);
    if (m) return +(m[1] || m[2] || m[3]);
    return s.indexOf('single') > -1 ? 1 : null;
  }
  /* -> {lo, hi, approx} or null */
  function stones(v, p) {
    var r = parsePieces(v.n) || (p.single ? parsePieces(p.n) : null);
    if (r) return { lo: r[0], hi: r[1], approx: false };
    var n = packCount(p.sold, p.title, v.t);
    if (n) return { lo: n, hi: n, approx: false, pack: true };
    var t = tier(v.t) || tier(p.title), lb = bagLb(p.sold, p.title);
    if (t && lb && lb <= 2.2) {
      var s = (p.stone || p.title || '').toLowerCase(), f = lb;
      for (var i = 0; i < RULES.heavy.length; i++) if (s.indexOf(RULES.heavy[i]) > -1) { f *= RULES.heavyFactor; break; }
      return { lo: Math.max(1, Math.round(RULES.typical1lb[t][0] * f)), hi: Math.max(1, Math.round(RULES.typical1lb[t][1] * f)), approx: true };
    }
    return null;
  }
  /* bagCost in dollars -> math object or null (data mismatch) */
  function math(bagCost, st, t, shelfOverride) {
    var mid = (st.lo + st.hi) / 2, cost = bagCost / mid;
    var retail = shelfOverride || Math.max(pricePointUp(cost * multipleFor(cost)), RULES.floors[t || 'single'] || 0);
    if (!shelfOverride && (cost < RULES.minCostPerStone || retail / cost > RULES.maxMultiple)) return null;
    return {
      bag: bagCost, mid: mid, cost: cost, costLo: bagCost / st.hi, costHi: bagCost / st.lo, retail: retail,
      multiple: retail / cost, revenue: retail * mid, profit: retail * mid - bagCost
    };
  }

  function money(x, cents) {
    if (x == null || isNaN(x)) return '-';
    var d = cents === false ? 0 : (x < 1 ? 2 : (Math.abs(x - Math.round(x)) < 0.005 ? 0 : 2));
    return '$' + x.toFixed(d);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* cost basis for one variant: wholesale customers pay price x factor; guests: shown retail x 0.5 */
  function bagCost(v, ctx) {
    var cents = ctx.wholesale ? v.p : Math.max(v.p, v.c || 0);
    return (cents / 100) * ctx.factor;
  }

  /* ---------------- product page ---------------- */
  function currentVariantId(root) {
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return f ? String(f.value) : (new URLSearchParams(location.search).get('variant') || '');
  }
  function renderPDP(root) {
    var data = JSON.parse(root.querySelector('[data-sbi-tm-data]').textContent);
    var ctx = data.ctx, p = data.product, body = root.querySelector('[data-sbi-tm-body]');
    var sel = currentVariantId(root), rows = [], best = null, anyApprox = false;
    data.variants.forEach(function (v) {
      var st = stones(v, p), t = tier(v.t) || tier(p.title);
      if (st && st.pack && st.lo === 1) t = 'single';
      var m = st ? math(bagCost(v, ctx), st, t) : null;
      if (st && st.approx) anyApprox = true;
      rows.push({ v: v, st: st, t: t, m: m });
      if (m && (!best || m.multiple > best.m.multiple)) best = { v: v, m: m };
    });
    var maxRev = 0;
    rows.forEach(function (r) { if (r.m) maxRev = Math.max(maxRev, r.m.revenue); });
    var h = '';
    var selRow = rows.filter(function (r) { return String(r.v.id) === sel && r.m; })[0] || rows.filter(function (r) { return r.m && r.t === 'm'; })[0] || rows.filter(function (r) { return r.m; })[0];
    if (!selRow) {
      body.innerHTML = '<p class="sbi-tm__note">We don\'t have a reliable stone count for this listing yet. Ask us and we\'ll count a bag for you: <a href="/pages/contact">contact us</a>.</p>';
      return;
    }
    var m = selRow.m;
    h += '<div class="sbi-tm__hero"><div class="sbi-tm__stat"><span>' + (ctx.wholesale ? 'Your cost' : 'Est. cost') + ' per stone</span><b>' + money(m.cost) + '</b></div>' +
      '<div class="sbi-tm__stat"><span>Suggested shelf price</span><b>' + money(m.retail) + '</b></div>' +
      '<div class="sbi-tm__stat sbi-tm__stat--hi"><span>Profit per bag</span><b>' + money(m.profit, false) + '</b></div>' +
      '<div class="sbi-tm__stat"><span>Markup</span><b>' + m.multiple.toFixed(1) + 'x</b></div></div>';
    h += '<p class="sbi-tm__lead"><b>' + esc(selRow.v.t) + '</b>: one ' + esc(p.sold || 'bag') + ' holds ' + (selRow.st.approx ? 'about ' : '') + selRow.st.lo + (selRow.st.hi !== selRow.st.lo ? '-' + selRow.st.hi : '') +
      ' stones. At ' + money(m.bag) + ' a bag that is ' + money(m.costLo) + (m.costHi - m.costLo > 0.005 ? '-' + money(m.costHi) : '') + ' a stone. Sell them at ' + money(m.retail) + ' and a typical bag brings in about <b>' + money(m.revenue, false) + '</b>.</p>';
    h += '<div class="sbi-tm__tablewrap"><table class="sbi-tm__table"><thead><tr><th>Size</th><th>Stones</th><th>Cost ea.</th><th>Sell at</th><th>Bag brings in</th><th class="sbi-tm__hide-s">Markup</th></tr></thead><tbody>';
    rows.forEach(function (r) {
      var on = String(r.v.id) === sel ? ' class="is-sel"' : '';
      if (!r.m) {
        h += '<tr' + on + '><td>' + esc(r.v.t) + '</td><td colspan="5" class="sbi-tm__muted">' + (r.st ? 'count under review - ask us' : 'ask us for a count') + '</td></tr>';
        return;
      }
      var w = maxRev ? Math.max(6, Math.round(r.m.revenue / maxRev * 100)) : 0;
      h += '<tr' + on + '><td>' + esc(r.v.t) + (r.v.q > 0 ? '' : ' <small class="sbi-tm__muted">(restocking)</small>') + '</td><td>' + (r.st.approx ? '~' : '') + r.st.lo + (r.st.hi !== r.st.lo ? '-' + r.st.hi : '') + '</td><td>' + money(r.m.cost) + '</td><td><b>' + money(r.m.retail) + '</b></td>' +
        '<td><span class="sbi-tm__bar"><i style="width:' + w + '%"></i></span>' + money(r.m.revenue, false) + '</td><td class="sbi-tm__hide-s">' + r.m.multiple.toFixed(1) + 'x</td></tr>';
    });
    h += '</tbody></table></div>';
    h += '<div class="sbi-tm__try"><label>Try your own shelf price for ' + esc(selRow.v.t) + ': $<input type="number" min="0.25" step="0.25" inputmode="decimal" value="' + m.retail + '" data-sbi-tm-shelf></label> <output data-sbi-tm-out></output></div>';
    h += '<p class="sbi-tm__fine">' + (ctx.wholesale ? 'Costs use your wholesale price (' + Math.round((1 - ctx.factor) * 100) + '% off retail). ' : 'Costs are estimated at the standard 50% wholesale discount on the retail price shown (approved accounts; sale items cost less). ') +
      'Stone counts are per bag; natural stones vary, so counts are ranges and we use the middle. ' + (anyApprox ? '~ = estimated from the size and bag weight. ' : '') +
      'Shelf prices are suggestions: cheaper, smaller stones get a higher markup, and a medium stone is priced at $2 or more.</p>';
    body.innerHTML = h;
    var inp = body.querySelector('[data-sbi-tm-shelf]'), out = body.querySelector('[data-sbi-tm-out]');
    function upd() {
      var x = parseFloat(inp.value);
      if (!(x > 0)) { out.textContent = ''; return; }
      var mm = math(m.bag, selRow.st, selRow.t, x);
      out.innerHTML = '&rarr; about <b>' + money(mm.revenue, false) + '</b> per bag, <b>' + money(mm.profit, false) + '</b> profit (' + mm.multiple.toFixed(1) + 'x)';
    }
    inp.addEventListener('input', upd); upd();
  }

  /* ---------------- collection calculator ---------------- */
  function renderCalc(root, rows, ctx) {
    var sel = root.querySelector('[data-sbi-calc-stone]'), size = root.querySelector('[data-sbi-calc-size]');
    var bags = root.querySelector('[data-sbi-calc-bags]'), out = root.querySelector('[data-sbi-calc-out]');
    var byName = {};
    rows.forEach(function (r) { (byName[r.name] = byName[r.name] || []).push(r); });
    var names = Object.keys(byName).sort();
    sel.innerHTML = names.map(function (n) { return '<option>' + esc(n) + '</option>'; }).join('');
    var pref = names.filter(function (n) { return /^Clear Quartz B$/.test(n); })[0] || names.filter(function (n) { return /^Rose Quartz B/.test(n); })[0] || names[0];
    sel.value = pref;
    function fillSizes() {
      var list = byName[sel.value] || [];
      size.innerHTML = list.map(function (r, i) { return '<option value="' + i + '">' + esc(r.t) + (r.q > 0 ? '' : ' (restocking)') + '</option>'; }).join('');
      var mi = -1;
      list.forEach(function (r, i) { if (mi < 0 && tier(r.t) === 'm' && r.q) mi = i; });
      if (mi < 0) list.forEach(function (r, i) { if (mi < 0 && r.q) mi = i; });
      if (mi < 0) list.forEach(function (r, i) { if (mi < 0 && tier(r.t) === 'm') mi = i; });
      if (mi < 0) mi = 0;
      size.value = String(mi);
    }
    function calc() {
      var r = (byName[sel.value] || [])[+size.value];
      if (!r) return;
      var st = { lo: r.lo, hi: r.hi, approx: r.ax }, t = tier(r.t) || 'm';
      var cost = ((ctx.wholesale ? r.p : Math.max(r.p, r.c || 0)) / 100) * ctx.factor;
      var m = math(cost, st, t), n = Math.max(1, parseInt(bags.value, 10) || 1);
      if (!m) { out.innerHTML = '<p>Ask us for a stone count on this one.</p>'; return; }
      var w1 = Math.round(m.bag / m.revenue * 100);
      out.innerHTML = '<div class="sbi-tc__nums">' +
        '<div><span>Stones in ' + n + ' bag' + (n > 1 ? 's' : '') + '</span><b>' + (st.approx ? '~' : '') + Math.round(m.mid * n) + '</b></div>' +
        '<div><span>' + (ctx.wholesale ? 'Your' : 'Est.') + ' cost / stone</span><b>' + money(m.cost) + '</b></div>' +
        '<div><span>Sell each at</span><b>' + money(m.retail) + '</b></div>' +
        '<div class="hi"><span>Profit</span><b>' + money(m.profit * n, false) + '</b></div></div>' +
        '<div class="sbi-tc__bars" aria-hidden="true"><div class="c" style="width:' + w1 + '%">You pay ' + money(m.bag * n, false) + '</div><div class="r">Your shelf brings in ' + money(m.revenue * n, false) + '</div></div>' +
        '<p class="sbi-tc__fine">' + m.multiple.toFixed(1) + 'x markup. ' + (st.approx ? 'Stone count estimated from size and bag weight. ' : '') + '<a href="/products/' + r.h + '">See this stone</a></p>';
    }
    sel.addEventListener('change', function () { fillSizes(); calc(); });
    size.addEventListener('change', calc);
    bags.addEventListener('input', calc);
    fillSizes(); calc();
  }

  window.SBITumble = { rules: RULES, tier: tier, stones: stones, math: math, renderPDP: renderPDP, renderCalc: renderCalc };
})();
